import http, { url } from '../../../http'

const API_URL = "followup-committee"
const API_URL2 = "followup-Committee"

class MeetingAPI {

  async save(meeting) {
    const response = await http(`${API_URL}/save`, 'POST', meeting)
    return response || null
  }

  async get(meetingID) {
    const response = await http(`${API_URL}-member/show-details/${meetingID}`)
    return response || null
  }

  async getActs(committeeID, page) {
    const response = await http(`${API_URL}/${committeeID}?page=${page}`, 'GET')
    return response || null
  }

  async update(meetingID, meeting) {
    const response = await http(`${API_URL}/update/${meetingID}`, 'PUT', meeting)
    return response || null
  }

  async saveMember(meetingID, memberID) {
    const response = await http(`${API_URL2}-member/save`, 'POST', {
      followup_committee_id: meetingID,
      employee_id: memberID,
    })
    return response || null
  }

  async getMembers(committeeID) {
    const response = await http(`${API_URL2}-member/show-members/${committeeID}`, 'GET')
    return response || null
  }

  getWordAct(actID) {
    return url(`followup-committee-act/${actID}`)
  }

}

export default new MeetingAPI()